import styled from 'styled-components';

export const CardsItemWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(11rem, 1fr));
  grid-gap: 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

export const ProtocolInfoWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 2fr 4fr 2fr;
  grid-gap: 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
    & > :nth-child(2) {
      order: -1;
    }
  }
`;

// charts
export const ChartContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: space-around;
`;

export const CustomLegend = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-height: 100px;
  overflow-y: auto;
  margin-bottom: 10px;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  margin: 5px;
`;

export const LegendColor = styled.span`
  display: inline-block;
  width: 12px;
  height: 12px;
  background-color: ${(props) => props.color};
  margin-right: 5px;
  border-radius: 50%;
`;

export const LegendLabel = styled.span`
  font-size: 14px;
`;
